const tabViewList = {
  OA_MANAGER: [
    {
      key: 'OA_MANAGER',
      name: 'OA',
      count: 0
    }
  ],
  CREATE_PRQ_CNOTE_TYPE: [
    {
      key: 'CREDIT',
      name: 'Credit'
    },
    {
      key: 'RETAIL',
      name: 'Retail'
    }
  ]
};

export default tabViewList;
